import React, { useState } from "react";
import { toast } from "react-toastify";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import UploadFile from "../../../../utilsComponent/Upload";
import { addAndClosingRemarks } from "../Investigation/investigationHelper";
import { REVIEW_TYPES, validFileTypes } from "../../../../consts";

const CloseMedicalReviewForm = ({ onClose, heading, modalData, claimDetails,roleDataCookie, setShowUpdatedRemarks, setNotified }) => {
  const [closingRemarks, setClosingRemarks] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingClose, setLoadingClose] = useState(false);


const handleCloseMedicalReview = async () => {
  setLoadingClose(true); 
  try {
    const result = await addAndClosingRemarks(
      modalData?.medicalReview?.investigationId,
      claimDetails?.claimId,
      modalData?.actionType,
      closingRemarks,
      REVIEW_TYPES.MEDICAL_REVIEW,
      roleDataCookie?.emailID ,
      uploadedFiles
    );

    if (result?.status === 'Success') {
      toast.success(result?.message);
      setShowUpdatedRemarks(true);
      if(modalData?.actionType === 'close')  {
        setNotified(true);
      }
      clearData();
    } else {
      toast.error(result?.message || 'Something went wrong');
    }
  } catch (error) {
    toast.error('Error while closing medical review');
    console.error(error);
  } finally {
    setLoadingClose(false); 
  }
};

const clearData = () => {
    setClosingRemarks('');
    setUploadedFiles([]);
    onClose();
  };

  if (loadingClose) return <LoadingPage kshemaLoader/>;

  return (
    <div className="field-survey-form">
      <div className="overlay-text-calc text-right me-7">
      </div>
      <div className="form-content-wrapper">
        <h4 className="form-heading">{heading}</h4>

        {/* Closing Remarks */}
        <div className="form-group">
          <label className="form-label">
           {modalData?.actionType === 'close' ? 'Closing Remarks' : 'Add Remarks'} <AsteriskSymbol />
          </label>
          <textarea
            className="form-control"
            placeholder={modalData?.actionType === 'close' ? 'Enter closing remarks' : 'Enter remarks'}
            value={closingRemarks}
            onChange={(e) => setClosingRemarks(e.target.value)}
            maxLength={600}
          />
          <div className="text-end small text-muted">
            {closingRemarks.length}/600 characters
          </div>
        </div>

        {/* Upload Report */}
        <div className="form-group">
          <UploadFile
            validType={validFileTypes}
            mandatory={modalData?.actionType === 'close'}
            addedFiles={uploadedFiles}
            setAddedFiles={setUploadedFiles}
            text="Upload Report"
            label="Upload Report"
          />
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-center gap-4">
          <button className="btn btn-outline-success" onClick={clearData}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={handleCloseMedicalReview}
            disabled={!closingRemarks.trim() || (modalData?.actionType === 'close' && uploadedFiles.length === 0)}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseMedicalReviewForm;